import axios from "axios";
import * as types from "../constant";

const stateData = {
  token: sessionStorage.getItem("userToken") || "",
  status: "",
  user: sessionStorage.getItem("userDetails") || ""
};

const gettersData = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  userIsAdmin: (state, getters) => {
    const roles = getters.currentAuthUser.roles;
    return roles.name === "Admin";
  },
  userIsUser: (state, getters) => {
    const roles = getters.currentAuthUser.roles;
    return roles.name === "User";
  },
  userIsJobseeker: (state, getters) => {
    const roles = getters.currentAuthUser.roles;
    return roles.name === "Jobseeker";
  },
  currentAuthUser: state => {
    let user;
    if (state.user) {
      user = JSON.parse(state.user);
    } else {
      user = JSON.parse(sessionStorage.getItem("userDetails"));
    }
    return user;
  }
};

const mutations = {
  [types.AUTH_REQUEST]: state => {
    const statedata = state;
    statedata.status = "loading";
  },
  [types.AUTH_SUCCESS]: (state, token) => {
    const statedata = state;
    const statetoken = token;

    statedata.token = statetoken;
    statedata.status = "success";
  },
  [types.USER_DETAILS]: (state, user) => {
    const statedata = state;
    statedata.user = user;
  },
  [types.AUTH_ERROR]: state => {
    const statedata = state;
    statedata.status = "error";
  },
  [types.AUTH_LOGOUT]: state => {
    const statedata = state;
    statedata.status = "";
    statedata.token = "";
    statedata.user = "";
  }
};

const actions = {
  [types.AUTH_REQUEST]: ({ commit }, user) =>
    new Promise((resolve, reject) => {
      commit(types.AUTH_REQUEST);
      axios
        .post([types.LOGIN_API], user)
        .then(resp => {
          const token = resp.data.data.token;
          const userData = resp.data.data.user;
          sessionStorage.setItem("userToken", token);
          sessionStorage.setItem("userDetails", JSON.stringify(userData));
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          commit(types.AUTH_SUCCESS, token);
          commit(types.USER_DETAILS, JSON.stringify(userData));
          resolve(resp);
        })
        .catch(err => {
          commit(types.AUTH_ERROR, err);
          sessionStorage.removeItem("userToken");
          sessionStorage.removeItem("userDetails");
          reject(err);
        });
    }),

  // onboard a company
  [types.COMPANY_AUTH_REGISTER]: ({ commit }, user) =>
    new Promise((resolve, reject) => {
      commit(types.AUTH_REQUEST);
      axios
        .post([types.COMPANY_AUTH_REGISTER], user)
        .then(resp => {
          const token = resp.data.data.token;
          const userData = resp.data.data.user;
          sessionStorage.setItem("userToken", token);
          sessionStorage.setItem("userDetails", JSON.stringify(userData));
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          commit(types.AUTH_SUCCESS, token);
          commit(types.USER_DETAILS, JSON.stringify(userData));
          resolve(resp);
        })
        .catch(err => {
          commit(types.AUTH_ERROR, err);
          sessionStorage.removeItem("userToken");
          sessionStorage.removeItem("userDetails");
          reject(err);
        });
    }),

  // onboard a jobseeker
  [types.JOBSEEKER_AUTH_REGISTER]: ({ commit }, user) =>
    new Promise((resolve, reject) => {
      commit(types.AUTH_REQUEST);
      axios
        .post([types.JOBSEEKER_AUTH_REGISTER], user)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          commit(types.AUTH_ERROR, err);
          sessionStorage.removeItem("userToken");
          sessionStorage.removeItem("userDetails");
          reject(err);
        });
    }),

  [types.AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(types.AUTH_LOGOUT);
      sessionStorage.removeItem("userToken");
      sessionStorage.removeItem("userDetails");
      delete axios.defaults.headers.common["Authorization"];
      resolve();
    }),

  [types.AUTH_LOGOUT]: ({ commit }) =>
    new Promise(resolve => {
      commit(types.AUTH_LOGOUT);
      sessionStorage.removeItem("userToken");
      sessionStorage.removeItem("userDetails");
      delete axios.defaults.headers.common["Authorization"];
      resolve();
    })
};

export default {
  state: stateData,
  getters: gettersData,
  mutations,
  actions
};
